import {SearchFilter, Value} from '../../shared/components/advanced-searchbox/advanced-searchbox.component';
import {Attribute, AttributeInputType} from '../models/attribute';
import {Filter, FilterConditionType, FilterField, FilterGroup} from '../../shared/models/magento-search-filter';

export class SearchFilterConverter {
    static readonly ADVANCED_FILTER_ATTRIBUTE_CODE = 'advanced';

    static createAdvancedFilterAttribute(): Attribute {
        return {
            code: this.ADVANCED_FILTER_ATTRIBUTE_CODE,
            isVisible: true,
            label: 'Advanced',
            inputType: AttributeInputType.TEXT,
            isSearchable: true,
            options: []
        };
    }

    convertToFilterGroup(searchFilters: SearchFilter[], attributes: Attribute[]): FilterGroup[] {
        console.log('convert search filters to filter group', searchFilters);

        const combinedFilters = this.combineFilter(searchFilters, attributes);

        const filterGroups: FilterGroup[] = [];
        for (const combinedFilter of combinedFilters) {
            let filterGroup: FilterGroup;
            if (combinedFilter.attribute.code === SearchFilterConverter.ADVANCED_FILTER_ATTRIBUTE_CODE) {
                filterGroup = this.createAdvancedFilterGroup(combinedFilter, attributes);
            } else if (combinedFilter.attribute.inputType === AttributeInputType.SELECT) {
                filterGroup = this.createInFilterGroup(combinedFilter);
            } else {
                filterGroup = this.createLikeFilterGroup(combinedFilter);
            }

            filterGroups.push(filterGroup);
        }

        return filterGroups;
    }

    private combineFilter(searchFilters: SearchFilter[], attributes: Attribute[]): CombinedFilter[] {
        const combinedFilters: CombinedFilter[] = [];
        for (const filter of searchFilters) {
            const attribute: Attribute = attributes.filter(a => a.code === filter.model)[0];

            const filterElement: CombinedFilter[] = combinedFilters.filter(f => f.attribute === attribute);
            if (filterElement.length === 0) {
                combinedFilters.push({attribute: attribute, values: [filter.value]});
            } else {
                filterElement[0].values.push(filter.value);
            }
        }
        return combinedFilters;
    }

    private createAdvancedFilterGroup(combinedFilter: CombinedFilter, attributes: Attribute[]): FilterGroup {
        console.log('create advanced filter group', combinedFilter.values);

        const filters: Filter[] = [];

        const searchableAttributes = attributes
            .filter(a => a.isSearchable
                && a.inputType === AttributeInputType.TEXT
                && a.code !== combinedFilter.attribute.code
                && a.code !== 'short_description');
        // excludes short description from advanced search because of a bug
        // have a look at: https://github.com/magento/magento2/issues/17254

        for (let value of combinedFilter.values[0].value.split(' ')) {
            value = this.encodeHtmlText(value);
            console.log('advanced search for', value);

            for (const attribute of searchableAttributes) {
                filters.push({
                    field: attribute.code as FilterField,
                    value: `%${value}%`,
                    conditionType: FilterConditionType.LIKE
                });
            }
        }

        return {
            filters: filters
        };
    }

    /**
     * Helper method decoding the given text and stripping html tags.
     *
     * @param text
     */
    private encodeHtmlText(text: string): string {
        if (text == null) {
            return null;
        }
        // const txt = document.createElement('textarea');
        // txt.appendChild(document.createTextNode(text));
        // return txt.value;

        // return $('<div>').text(text).html();

        const htmlEncode = require('htmlencode');
        return htmlEncode.htmlEncode(text);
    }

    private createLikeFilterGroup(combinedFilter: CombinedFilter): FilterGroup {
        const field = combinedFilter.attribute.code as FilterField;
        console.log('filter field', field);

        const filters: Filter[] = [];
        for (const value of combinedFilter.values) {
            filters.push({
                field: field,
                value: `%${value.value}%`,
                conditionType: FilterConditionType.LIKE
            });
        }

        return {
            filters: filters
        };
    }

    private createInFilterGroup(combinedFilter: CombinedFilter): FilterGroup {
        return {
            filters: [{
                field: combinedFilter.attribute.code as FilterField,
                value: combinedFilter.values.map(v => v.value).toString(),
                conditionType: FilterConditionType.IN
            }]
        };
    }

}

interface CombinedFilter {
    attribute: Attribute;
    values: Value[];
}
